import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    margin: `10px 0`,
  },

  box: {
    backgroundColor: theme.palette.common.white,
    borderRadius: theme.palette.border.radius,
    border: theme.palette.border.default,
    padding: '5px 15px',
    marginTop: 5,
  },

  button: {
    '& .MuiButton-label': {
      justifyContent: 'space-between',
    },
    '& .MuiButton-endIcon': {
      transform: 'rotate(0deg)',
      marginLeft: 'auto',
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.standard,
      }),
    },
  },

  expandOpen: {
    '& .MuiButton-endIcon': {
      transform: 'rotate(180deg)',
    },
  },
  infoIcon: {
    fontSize: theme.typography.pxToRem(16),
    marginLeft: 11,
    color: theme.palette.primary.main
  },
}));

export default useStyles;
